// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    viewBox="0 0 48 48"
    {...props}
  >
    <g className="layer">
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#252F38"
          d="M708.27 421.9c-6.97 0-14.66 3.89-17.72 10.87l-32.59 74.71-11.74-74.71c-1.38-6.98-6.13-10.87-13.64-10.87l-41.28 0 35.31 124.07c.65 2.37.77 5.01.3 7.79-1.85 10.35-11.74 18.75-22.1 18.75l-23.12 0c-5.87 0-9.73 3.63-11.62 11.87l-5.14 30.74 40.72 0c21.24 0 46.18-10.67 62.82-40.18l81.53-153.04-41.73 0zM307.49 384.88c12.2 0 18.09 4.86 15.94 17.08l-3.51 19.91 28.01 0-6.17 34.99-28.03 0-7.63 43.31c-2.64 15.09 12.3 17.1 20.87 17.1 1.71 0 3.12-.04 4.14-.1l-6.85 39.01c-2.12.22-4.3.52-8.91.52-21.27 0-61.5-5.7-53.59-50.58l8.66-49.26-20.42 0 6.15-34.98 20.22 0 6.51-37 24.61 0z"
          transform="matrix(.09248 0 0 .09248 -22.12 -21.595)"
        />
        <path
          fill="#009FAE"
          d="m542.89 423.48-7.19 40.78c8.87 4.54 14.95 13.74 14.95 24.37 0 14.02-10.51 25.51-24.04 27.16l-7.19 40.78c1.27.08 2.56.12 3.85.12 37.61 0 68.07-30.48 68.07-68.06 0-30.72-20.4-56.71-48.45-65.15M510.86 513.01c-8.87-4.5-14.96-13.75-14.96-24.37 0-13.93 10.53-25.51 24.06-27.13l7.18-40.78c-1.28-.08-2.58-.14-3.86-.14-37.58 0-68.05 30.5-68.05 68.05 0 30.74 20.41 56.75 48.45 65.19l7.18-40.82z"
          transform="matrix(.09248 0 0 .09248 -22.12 -21.595)"
        />
        <path
          fill="#252F38"
          d="m364.15 421.9 24.07 0c12.2 0 18.06 4.87 15.91 17.1l-2.63 14.79c8.97-18.2 28.42-33.22 48.38-33.22 2.61 0 5.13.52 5.13.52l-7.78 44.11c0 0-3.49-.81-8.94-.81-10.63 0-28.62 3.37-38.63 23.35-2.38 4.92-4.22 10.91-5.49 18.13l-8.71 49.55-44.84 0 23.53-133.52zM739.01 558.46c0-.79-.26-1.45-.83-1.99-.55-.53-1.26-.79-2.14-.79l-2.94 0 0 5.54 2.94 0c.88 0 1.59-.28 2.14-.78.57-.52.83-1.17.83-1.98m2.65 11.06-2.56 0-3.62-6.44-2.38 0 0 6.44-2.17 0 0-15.78 5.35 0c1.38 0 2.56.47 3.52 1.36.96.91 1.47 2.03 1.47 3.36 0 2.2-1.15 3.65-3.4 4.34l3.79 6.72zm6.08-7.88c0 3.4-1.19 6.3-3.57 8.68-2.35 2.4-5.24 3.59-8.57 3.59-3.32 0-6.17-1.19-8.54-3.59-2.35-2.38-3.52-5.28-3.52-8.68 0-3.39 1.17-6.27 3.52-8.67 2.37-2.41 5.22-3.6 8.54-3.6 3.33 0 6.22 1.19 8.57 3.6 2.38 2.4 3.57 5.28 3.57 8.67m2.26 0c0 3.98-1.41 7.38-4.22 10.18-2.79 2.8-6.18 4.23-10.18 4.23-3.96 0-7.35-1.43-10.17-4.23-2.81-2.8-4.22-6.2-4.22-10.18 0-3.97 1.41-7.36 4.22-10.18 2.82-2.8 6.21-4.21 10.17-4.21 4 0 7.39 1.41 10.18 4.21 2.81 2.82 4.22 6.21 4.22 10.18"
          transform="matrix(.09248 0 0 .09248 -22.12 -21.595)"
        />
      </g>
    </g>
  </svg>
);
const LogoTroy = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default LogoTroy;
